<div class="ac-modal container">
	<div class="header">
		<h3 class="title" dcrHTMLKey="CUSTOMIZE_ADVISORY_FEE_TITLE">Set Your Advisory Fee</h3>
	</div>

	<div class="content">
		<div class="margin-bottom-16 text-14 text-align-left" dcrHTMLKey="CUSTOMIZE_ADVISORY_FEE_DESCRIPTION">
			Include your advisory fee in order to calculate the net performance of your portfolio(s).
		</div>
		<dz-toggle-switch
			*ngIf="!disableFeeExclusion"
			class="text-14-bold"
			[toggleOn]="includeCustomFee"
			[toggleLabel]="'Include Custom Fee' | dcr: 'INCLUDE_CUSTOM_FEE_TEXT'"
			[dcrKeys]="['INCLUDE_CUSTOM_FEE_TEXT']"
			(click)="toggleCustomFee()"
			custom-tracking
			[track-event]="'customize advisory fee dialog:button:custom fee toggle:' + (includeCustomFee ? 'off' : 'on')"
		>
		</dz-toggle-switch>

		<div class="user-input-field margin-bottom-8" [class.disabled]="!includeCustomFee">
			<div class="advisory-fee-input-description text-12" data-cy="custom-advisory-fee-input-desc" dcrHTMLKey="CUSTOM_ADVISORY_FEE_INPUT_DESCRIPTION">
				Custom Advisory Fee
			</div>
			<div class="advisory-fee-input">
				<input [formControl]="customFee" type="number" (blur)="onBlur()" (keyup.enter)="onBlur(); onCalculateClick()" />
				<p class="percentage-sign text-16-bold" dcrHTMLKey="CUSTOMIZE_ADVISORY_FEE_PERCENTAGE">%</p>
			</div>
		</div>

		<div
			class="warning-message margin-bottom-8 text-14"
			*ngIf="includeCustomFee && !isAdvisoryFeeValid && !isAdvisoryFeeEmpty"
			dcrHTMLKey="ADVISORY_FEE_WARNING"
			[dcrSubstitutions]="{ $minimumAdvisoryFee$: customAdvisoryFee.minimumFee, $maximumAdvisoryFee$: customAdvisoryFee.maximumFee }"
		>
			Fee is invalid. Please enter a percentage between $minimumAdvisoryFee$% and $maximumAdvisoryFee$%.
		</div>

		<div class="text-condensed-14 margin-top-16" dcrHTMLKey="CUSTOM_FEE_DIALOG_DISCLOSURE" [dcrSubstitutions]="{ $defaultFee$: customAdvisoryFee.defaultFee }">
			By changing this default investment advisory fee of $defaultFee$%, or removing the advisory fee altogether, you are representing that the fee input accurately reflects
			the fee that is applicable to your client's account.
		</div>

		<div *ngIf="enableDisclaimerNote" class="text-condensed-14 margin-top-16" [dcrHTMLKey]="disclaimerNoteDCR">
			By adding the portfolio's twelve month trailing yield to the scenario results, the scenarios will now have a one year time horizon and will no longer be instantaneous
			shocks. Therefore the full annual advisory fee will be deducted from the results.
		</div>

		<div class="d-flex align-items-center margin-top-32 justify-content-right">
			<button
				dz-button
				[disabled]="includeCustomFee && (!isAdvisoryFeeValid || isAdvisoryFeeEmpty)"
				(click)="onCalculateClick()"
				data-cy="apply-button"
				dcrHTMLKey="APPLY_BUTTON_TEXT"
				track-event="customize advisory fee dialog:button:calculate"
			>
				Apply
			</button>
		</div>
	</div>
</div>
